<template>
    <div v-if="loading && models.length === 0" class="pt-10 pb-6 lg:py-10">
        <div class="text-center mb-6">
            <loadingcircle size="10"></loadingcircle>
        </div>
    </div>
    <div v-else>
        <section
            class="section-dropdowns bg-greyPrimary sticky top-0"
            :class="{ 'z-20': !displayGalleryModal }"
        >
            <div class="container px-6 py-4 lg:py-8">
                <div class="max-w-2xl mx-auto lg:max-w-6xl">
                    <div class="flex w-full gap-4 md:gap-8">
                        <dropdown
                            :allModels="allModels"
                            :model="model1"
                            @model-selected="(model) => (model1 = model)"
                        ></dropdown>
                        <dropdown
                            :allModels="allModels"
                            :model="model2"
                            @model-selected="(model) => (model2 = model)"
                        ></dropdown>
                    </div>
                </div>
            </div>
        </section>

        <div class="relative">
            <section
                class="section-models section-p"
                :class="{ 'section-p-no-b': models.length }"
            >
                <div class="container px-6">
                    <div class="max-w-2xl mx-auto lg:max-w-6xl">
                        <div
                            class="flex w-full gap-4 md:gap-8"
                            :class="{ 'justify-center': !model1 && !model2 }"
                        >
                            <p
                                v-if="!allModels.length"
                                class="text-center"
                                style="opacity: 0.5"
                            >
                                {{
                                    "Please reload the page to load the floor plans"
                                }}
                            </p>
                            <p
                                v-if="!model1 && !model2"
                                class="text-center"
                                style="opacity: 0.5"
                            >
                                {{
                                    "Please select two floor plans to compare them"
                                }}
                            </p>
                            <div
                                v-else
                                class="w-1/2"
                                v-for="(model, index) in [model1, model2]"
                            >
                                <div
                                    v-if="model === 0"
                                    class="flex justify-center flex-col h-full"
                                >
                                    <p style="opacity: 0.5" class="text-center">
                                        {{ "Please select another floor plan" }}
                                    </p>
                                </div>
                                <div
                                    v-else-if="model1 === model2 && index === 1"
                                    class="flex items-center justify-center flex-col h-full"
                                >
                                    <p style="opacity: 0.7">
                                        {{
                                            "Please select different floor plan than the first one selected"
                                        }}
                                    </p>
                                </div>
                                <div v-else>
                                    <div
                                        ref="openGalleryTrigger"
                                        data-position="0"
                                        class="relative js-open-gallery cursor-pointer w-full border border-solid border-greyTan bg-white min-h-[154px] md:min-h-[220px] lg:min-h-[440px] lg:max-w-[560px] flex items-center"
                                        @click="openModal(model)"
                                    >
                                        <img
                                            class="w-full px-4 pt-4 md:px-8 md:pt-8 md:pb-2 lg:px-12 lg:pt-12"
                                            :src="model.floorPlan"
                                            :title="model.title"
                                            v-if="model.floorPlan"
                                            :alt="model.title"
                                        />

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="w-14 text-offBlack p-5 mx-auto md:ml-auto md:mr-0 absolute bottom-0 right-0"
                                        >
                                            <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                            <path
                                                fill="currentColor"
                                                d="M288 192H224V128c0-8.844-7.156-16-16-16S192 119.2 192 128v64H128C119.2 192 112 199.2 112 208S119.2 224 128 224h64v64c0 8.844 7.156 16 16 16S224 296.8 224 288V224h64c8.844 0 16-7.156 16-16S296.8 192 288 192zM507.3 484.7l-141.5-141.5C397 306.8 416 259.7 416 208C416 93.13 322.9 0 208 0S0 93.13 0 208S93.13 416 208 416c51.68 0 98.85-18.96 135.2-50.15l141.5 141.5C487.8 510.4 491.9 512 496 512s8.188-1.562 11.31-4.688C513.6 501.1 513.6 490.9 507.3 484.7zM208 384C110.1 384 32 305 32 208S110.1 32 208 32S384 110.1 384 208S305 384 208 384z"
                                            />
                                        </svg>
                                    </div>

                                    <div
                                        class="flex items-center flex-col gap-4 pt-4"
                                    >
                                        <div
                                            class="flex flex-col md:flex-row justify-start md:justify-center text-offBlack w-full"
                                            title=""
                                        >
                                            <p
                                                v-if="model.numberOfSeats"
                                                class="flex justify-start items-center text-offBlack mb-2 md:mb-0 mr-6"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 448 512"
                                                    class="w-3 mr-2"
                                                >
                                                    <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                                    <path
                                                        fill="currentColor"
                                                        d="M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z"
                                                    />
                                                </svg>
                                                <span>
                                                    {{ model.numberOfSeats }}
                                                    travellers
                                                </span>
                                            </p>
                                            <p
                                                v-if="model.waterCapacity"
                                                class="flex justify-start items-center text-offBlack mb-2 md:mb-0 mr-6"
                                                title="Water capacity"
                                            >
                                                <svg
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    data-prefix="fal"
                                                    data-icon="droplet"
                                                    class="w-5 svg-inline--fa fa-droplet fa-w-20"
                                                    role="img"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 640 512"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M192 400C200.8 400 208 407.2 208 416C208 424.8 200.8 432 192 432C130.1 432 80 381.9 80 319.1C80 311.2 87.16 303.1 96 303.1C104.8 303.1 112 311.2 112 319.1C112 364.2 147.8 400 192 400zM368 319.1C368 417.2 289.2 496 192 496C94.8 496 16 417.2 16 319.1C16 245.9 118.3 89.43 166.9 19.3C179.2 1.585 204.8 1.585 217.1 19.3C265.7 89.43 368 245.9 368 319.1zM321.5 263.4C311.8 238.9 298.2 211.6 282.8 183.7C252.4 128.8 216.1 74.13 192 39.32C167.9 74.13 131.6 128.8 101.2 183.7C85.77 211.6 72.17 238.9 62.51 263.4C52.57 288.5 48 307.6 48 319.1C48 399.5 112.5 464 192 464C271.5 464 336 399.5 336 319.1C336 307.6 331.4 288.5 321.5 263.4V263.4z"
                                                    />
                                                </svg>
                                                <span
                                                    >{{
                                                        model.waterCapacity
                                                    }}L</span
                                                >
                                            </p>
                                            <p
                                                v-if="model.lengthOfTheUnit"
                                                class="flex justify-start items-center text-offBlack mb-2 md:mb-0"
                                                title="Length"
                                            >
                                                <svg
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    data-prefix="fal"
                                                    data-icon="arrows-h"
                                                    class="mr-2 w-5 svg-inline--fa fa-arrows-h fa-w-16"
                                                    role="img"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M399.959 170.585c-4.686 4.686-4.686 12.284 0 16.971L451.887 239H60.113l51.928-51.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-84.485 84c-4.686 4.686-4.686 12.284 0 16.971l84.485 84c4.686 4.686 12.284 4.686 16.97 0l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273h391.773l-51.928 51.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l84.485-84c4.687-4.686 4.687-12.284 0-16.971l-84.485-84c-4.686-4.686-12.284-4.686-16.97 0l-7.07 7.071z"
                                                    ></path>
                                                </svg>
                                                {{ model.lengthOfTheUnit }} mm
                                            </p>
                                        </div>
                                        <div
                                            class="flex justify-start items-center md:justify-center text-offBlack w-full"
                                        >
                                            <p class="sml mb-0 mr-2">From</p>
                                            <p class="tracking-wider">
                                                {{
                                                    model.fromPrice === null
                                                        ? "POA"
                                                        : "$" +
                                                          Number(
                                                              model.fromPrice
                                                          ).toLocaleString()
                                                }}
                                            </p>
                                        </div>

                                        <a
                                            v-if="model.uri"
                                            :href="model.uri"
                                            class="button primary self-start md:self-center"
                                            >Learn more</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                v-if="loading && models.length === 0"
                class="pt-10 pb-6 lg:py-10"
            >
                <div class="text-center mb-6">
                    <loadingcircle size="10"></loadingcircle>
                </div>
            </section>
            <section v-else-if="models.length" class="section-p">
                <div class="container px-6">
                    <div class="max-w-2xl mx-auto lg:max-w-6xl">
                        <div
                            :class="{
                                'pb-12 md:pb-16':
                                    index !== Object.keys(models[0]).length - 1,
                            }"
                            v-for="(details, header, index) in models[0]"
                            :key="index"
                        >
                            <div class="table-header-wrapper">
                                <h3 class="table-header">{{ header }}</h3>
                            </div>

                            <table>
                                <tr
                                    v-for="(fact, key) in details"
                                    :key="key"
                                    :title="icons[key].title"
                                >
                                    <td>
                                        <div class="flex">
                                            <div class="icon-wrapper">
                                                <span
                                                    class="my-auto"
                                                    v-html="icons[key].icon"
                                                ></span>
                                            </div>
                                            <span>{{
                                                fact
                                                    ? icons[key].prefix +
                                                      fact +
                                                      icons[key].suffix
                                                    : icons[key].prefix + "-"
                                            }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="flex">
                                            <div class="icon-wrapper">
                                                <span
                                                    class="my-auto"
                                                    v-html="icons[key].icon"
                                                ></span>
                                            </div>
                                            <span>{{
                                                models[1][header][key]
                                                    ? icons[key].prefix +
                                                      models[1][header][key] +
                                                      icons[key].suffix
                                                    : icons[key].prefix + "-"
                                            }}</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- start gallery overlay -->
        <div
            class="fixed top-0 bottom-0 left-0 w-full h-screen bg-overlayB flex items-center overlay-gallery"
            ref="overlay"
            v-if="galleryModel && displayGalleryModal"
        >
            <div class="container mx-auto md:px-6 lg:px-20 xxl:px-40">
                <swiper
                    :slides-per-view="1"
                    :space-between="0"
                    :centered-slides="true"
                    :loop="false"
                    :speed="500"
                    :keyboard="{
                        enabled: true,
                    }"
                    :pagination="{
                        el: '.swiper-pagination',
                        clickable: true,
                        type: 'fraction',
                    }"
                    :navigation="true"
                    :modules="modules"
                    :grab-cursor="false"
                    class="swiper-container swiper-gallery-modal"
                >
                    <swiper-slide
                        class="swiper-slide"
                        :data-position="index"
                        v-for="(count, index) in [
                            'floorPlan',
                            'floorPlan2',
                            'image',
                        ]"
                    >
                        <div
                            class="w-full px-6 xl:px-14"
                            v-if="
                                typeof galleryModel[count] == 'string' ||
                                galleryModel[count] instanceof String
                            "
                        >
                            <div class="w-full bg-white">
                                <div class="w-full py-6 px-8 xl:px-14">
                                    <picture>
                                        <img
                                            width="1120"
                                            height="632"
                                            class="object-cover w-full h-full lazy"
                                            loading="lazy"
                                            :src="galleryModel[count]"
                                            :alt="galleryModel['title']"
                                        />
                                    </picture>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>

                    <template v-slot:container-start>
                        <div
                            class="flex justify-end xl:absolute xl:right-0 xl:top-0 mr-6 xl:mt-0 z-20 xl:mr-0"
                            @click="openModal"
                        >
                            <a id="js-close-modal-gallery" class="close">
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fal"
                                    data-icon="times"
                                    class="w-4 svg-inline--fa fa-times fa-w-10"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                    </template>
                </swiper>
            </div>
        </div>
        <!-- end gallery overlay -->
    </div>
</template>

<script>
import loadingcircle from "../loading-circle.vue";
import Product from "../filters/Product.vue";
import dropdown from "./Dropdown.vue";
import { watch, ref, onMounted } from "vue";
import Cookies from "js-cookie";
import { Keyboard, Navigation, Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
const axios = require("axios");
export default {
    components: { Product, loadingcircle, dropdown, SwiperSlide, Swiper },
    // check if we have any models requested via URL
    created() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("model1")) {
            Cookies.set("model1", decodeURI(urlParams.get("model1")));
        }
        if (urlParams.has("model2")) {
            Cookies.set("model2", decodeURI(urlParams.get("model2")));
        }
    },
    setup() {
        const models = ref([]); // this will hold the information from the models 1 and 2 e.g. their Quick facts, Special features and Weights and dimensions
        const allModels = ref([]); // this is the info for the dropdowns. basically the models and series; their names and images (simple data)
        const model1 = ref(0); // model 1 selected from the first dropdown
        const model2 = ref(0); // model 2 selected from the second dropdown
        const galleryModel = ref(0); // the model that is going to be shown on the pop up modal (to display its images)

        const app = ref(null); //  elements from the DOM that are needed for the pop up modal
        const header = ref(null); // same

        const loading = ref(true); // loading status
        const displayGalleryModal = ref(false); // toggle for displaying the pop up modal or not
        const icons = ref({
            waterCapacity: {
                title: "Fresh water",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="w-4"><path fill="currenColor" d="M192 400C200.8 400 208 407.2 208 416C208 424.8 200.8 432 192 432C130.1 432 80 381.9 80 319.1C80 311.2 87.16 303.1 96 303.1C104.8 303.1 112 311.2 112 319.1C112 364.2 147.8 400 192 400zM368 319.1C368 417.2 289.2 496 192 496C94.8 496 16 417.2 16 319.1C16 245.9 118.3 89.43 166.9 19.3C179.2 1.585 204.8 1.585 217.1 19.3C265.7 89.43 368 245.9 368 319.1zM321.5 263.4C311.8 238.9 298.2 211.6 282.8 183.7C252.4 128.8 216.1 74.13 192 39.32C167.9 74.13 131.6 128.8 101.2 183.7C85.77 211.6 72.17 238.9 62.51 263.4C52.57 288.5 48 307.6 48 319.1C48 399.5 112.5 464 192 464C271.5 464 336 399.5 336 319.1C336 307.6 331.4 288.5 321.5 263.4V263.4z"/></svg>',
                prefix: "Fresh water: ",
                suffix: "L",
            },
            greyWater: {
                title: "Grey water",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="w-4"><path fill="currenColor"  d="M16 319.1C16 245.9 118.3 89.43 166.9 19.3C179.2 1.585 204.8 1.585 217.1 19.3C265.7 89.43 368 245.9 368 319.1C368 417.2 289.2 496 192 496C94.8 496 16 417.2 16 319.1zM112 319.1C112 311.2 104.8 303.1 96 303.1C87.16 303.1 80 311.2 80 319.1C80 381.9 130.1 432 192 432C200.8 432 208 424.8 208 416C208 407.2 200.8 400 192 400C147.8 400 112 364.2 112 319.1z"/></svg>',
                prefix: "Grey water: ",
                suffix: "L ",
            },
            solar: {
                title: "Solar (Watts)",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4"><path fill="currenColor"  d="M256 128c-70.58 0-127.1 57.42-127.1 127.1S185.4 383.1 256 383.1s127.1-57.42 127.1-127.1S326.6 128 256 128zM256 351.1c-53.02 0-95.1-42.98-95.1-95.1C160 202.1 202.1 159.1 256 159.1s95.1 42.98 95.1 95.1C351.1 309 309 351.1 256 351.1zM453.7 256l52.87-76.18c5.922-8.529 7.062-19.34 3.094-28.9c-3.969-9.561-12.42-16.37-22.61-18.22l-91.26-16.5l-16.48-91.24c-1.859-10.22-8.672-18.65-18.25-22.62c-9.531-3.969-20.34-2.781-28.88 3.094L256 58.33L179.8 5.455c-8.5-5.906-19.25-7.125-28.84-3.125C141.4 6.299 134.5 14.73 132.7 24.95L116.2 116.2l-91.25 16.5C14.75 134.5 6.301 141.4 2.332 150.9C-1.637 160.5-.4961 171.3 5.426 179.8L58.3 256l-52.87 76.18c-5.922 8.531-7.062 19.34-3.094 28.9s12.42 16.37 22.61 18.22l91.26 16.5l16.48 91.24c1.859 10.22 8.688 18.65 18.27 22.62c3.75 1.562 7.688 2.312 11.59 2.312c6.078 0 12.08-1.844 17.25-5.406L256 453.7l76.2 52.87c8.5 5.906 19.25 7.125 28.84 3.125c9.578-3.969 16.41-12.41 18.27-22.62l16.48-91.24l91.25-16.5c10.2-1.844 18.66-8.654 22.62-18.22s2.828-20.37-3.094-28.9L453.7 256zM379.2 366.3c-6.578 1.188-11.72 6.344-12.91 12.9l-15.83 101.1l-85.33-59.21c-5.5-3.812-12.75-3.812-18.25 0l-82.69 60.31L145.7 379.2c-1.188-6.561-6.328-11.72-12.91-12.9l-101.1-15.84l59.2-85.31c3.812-5.498 3.812-12.75 0-18.25l-60.28-82.68l102.2-18.47C139.4 144.5 144.5 139.4 145.7 132.8l15.83-101.1l85.33 59.21c5.5 3.811 12.75 3.811 18.25 0l82.69-60.31l18.47 102.2c1.188 6.562 6.328 11.72 12.91 12.91l101.1 15.84l-59.2 85.31c-3.812 5.5-3.812 12.75 0 18.25l57.7 83.15L379.2 366.3z"/></svg>',
                prefix: "Solar: ",
                suffix: "W",
            },
            engine: {
                title: "Engine (hp)",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M301.4 122.7L269.8 224H330.5C342.4 224 352 233.6 352 245.5C352 251.6 349.4 257.4 344.9 261.5L180 410.7C176.3 414.1 171.3 416 166.2 416C152.3 416 142.4 402.5 146.6 389.3L178.2 288H116.9C105.4 288 96 278.6 96 267.1C96 261.2 98.48 255.6 102.8 251.6L267.9 101.4C271.7 97.91 276.6 96 281.8 96C295.7 96 305.6 109.5 301.4 122.7L301.4 122.7zM200 256C205.1 256 209.9 258.4 212.9 262.5C215.9 266.6 216.8 271.9 215.3 276.8L189.6 358.9L303.3 256H248C242.9 256 238.1 253.6 235.1 249.5C232.1 245.4 231.2 240.1 232.7 235.2L258.3 153.4L145.5 256H200zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM32 96V416C32 433.7 46.33 448 64 448H384C401.7 448 416 433.7 416 416V96C416 78.33 401.7 64 384 64H64C46.33 64 32 78.33 32 96z"/></svg>',
                prefix: "Engine: ",
                suffix: "",
            },
            buildWarranty: {
                title: "Build warranty",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M466.5 83.71l-192-80c-5.875-2.5-12.16-3.703-18.44-3.703S243.5 1.203 237.6 3.703L45.61 83.71C27.73 91.08 16 108.6 16 127.1C16 385.4 205.4 512 255.9 512C305.2 512 496 387.3 496 127.1C496 108.6 484.3 91.08 466.5 83.71zM463.9 128.3c0 225.3-166.2 351.7-207.8 351.7C213.3 479.1 48 352.2 48 128c0-6.5 3.875-12.25 9.75-14.75l192-80c1.973-.8275 4.109-1.266 6.258-1.266c2.071 0 4.154 .4072 6.117 1.266l192 80C463.3 117.1 463.9 125.8 463.9 128.3zM336 181.3c-4.094 0-8.188 1.562-11.31 4.688L229.3 281.4L187.3 239.4C184.2 236.2 180.1 234.7 176 234.7c-9.139 0-16 7.473-16 16c0 4.094 1.562 8.188 4.688 11.31l53.34 53.33C221.2 318.4 225.3 320 229.3 320s8.188-1.562 11.31-4.688l106.7-106.7C350.4 205.5 352 201.4 352 197.3C352 188.8 345.1 181.3 336 181.3z"/></svg>',
                prefix: "",
                suffix: "",
            },

            battery: {
                title: "Battery (Amp/hour)",
                icon: '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="battery-full" class="w-5 lg:w-6 svg-inline--fa fa-battery-full fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M560 128c8.823 0 16 7.177 16 16v48h32v128h-32v48c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V144c0-8.823 7.177-16 16-16h512m0-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zM128 314V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"></path></svg>',
                prefix: "Battery: ",
                suffix: "",
            },
            frontOrRearWheelDrive: {
                title: "Front or Rear Wheel Drive",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M96 256C96 167.6 167.6 96 256 96C344.4 96 416 167.6 416 256C416 344.4 344.4 416 256 416C167.6 416 96 344.4 96 256zM381.7 280.2C383.2 272.3 384 264.3 384 256C384 219.2 368.5 186.1 343.7 162.7L305.5 215.4C314.5 226.4 320 240.6 320 256C320 257.4 319.1 258.7 319.9 260L381.7 280.2zM309.9 290.4C301.3 303.9 287.8 313.9 271.9 317.1L271.1 383C316.2 377.5 353.5 349.4 371.8 310.6L309.9 290.4zM239.1 383L239.9 317.1C224.1 313.9 210.6 303.9 202.1 290.4L140.2 310.6C158.5 349.4 195.7 377.5 239.1 383V383zM192.1 260C192 258.7 192 257.4 192 256C192 240.6 197.5 226.4 206.5 215.4L168.3 162.7C143.5 186.1 128 219.2 128 255.1C128 264.3 128.8 272.3 130.3 280.2L192.1 260zM232.4 196.5C239.7 193.6 247.7 192 256 192C264.3 192 272.3 193.6 279.6 196.5L317.8 143.9C299.5 133.8 278.4 128 256 128C233.6 128 212.5 133.8 194.2 143.9L232.4 196.5zM256 224C238.3 224 224 238.3 224 256C224 273.7 238.3 288 256 288C273.7 288 288 273.7 288 256C288 238.3 273.7 224 256 224zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"/></svg>',
                prefix: "",
                suffix: " wheel drive",
            },
            ////
            ///
            gvm: {
                title: "GVM",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M509.9 431.4l-68.43-267.7C436.2 142.7 417.9 128 397 128h-77.38c10.15-13.41 16.38-29.92 16.38-48c0-44.13-35.89-80-80.01-80S175.1 35.88 175.1 80c0 18.08 6.23 34.59 16.38 48H114.1C94.1 128 75.8 142.7 70.53 163.6l-68.45 267.8c-5.08 19.81-.75 41.13 11.6 57.03C25.29 503.4 42.53 512 60.95 512h390.1c18.42 0 35.66-8.594 47.27-23.59C510.7 472.5 514.1 451.2 509.9 431.4zM256 32c26.47 0 48.01 21.53 48.01 48S282.5 128 256 128S207.1 106.5 207.1 80S229.5 32 256 32zM473 468.8C467.4 476 459.6 480 451 480H60.95c-8.578 0-16.39-3.969-21.99-11.19c-6.33-8.156-8.518-19.16-5.877-29.47L101.6 171.5C103.3 164.7 108.8 160 114.1 160h282c6.205 0 11.74 4.719 13.46 11.56l68.45 267.8C481.6 449.6 479.4 460.7 473 468.8z"/></svg>',
                prefix: "GVM: ",
                suffix: " kg",
            },

            heightOfTheUnit: {
                title: "External height",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="w-4" style="height:1.25rem"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M139.3 4.688l112 112C254.4 119.8 256 123.9 256 128s-1.562 8.188-4.688 11.31c-6.25 6.25-16.38 6.25-22.62 0L144 54.63v402.8l84.69-84.69c6.25-6.25 16.38-6.25 22.62 0C254.4 375.8 256 379.9 256 384s-1.562 8.188-4.688 11.31l-112 112c-6.25 6.25-16.38 6.25-22.62 0l-112-112c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0L112 457.4V54.63L27.31 139.3c-6.25 6.25-16.38 6.25-22.62 0s-6.25-16.38 0-22.62l112-112C122.9-1.562 133.1-1.562 139.3 4.688z"/></svg>',
                prefix: "External height: ",
                suffix: " mm",
            },

            lengthOfTheUnit: {
                title: "Length",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M507.3 267.3l-112 112C392.2 382.4 388.1 384 384 384s-8.188-1.562-11.31-4.688c-6.25-6.25-6.25-16.38 0-22.62L457.4 272H54.63l84.69 84.69c6.25 6.25 6.25 16.38 0 22.62C136.2 382.4 132.1 384 128 384s-8.188-1.562-11.31-4.688l-112-112c-6.25-6.25-6.25-16.38 0-22.62l112-112c6.25-6.25 16.38-6.25 22.62 0s6.25 16.38 0 22.62L54.63 240h402.8l-84.69-84.69c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0l112 112C513.6 250.9 513.6 261.1 507.3 267.3z"/></svg>',
                prefix: "Length: ",
                suffix: " mm ",
            },

            tare: {
                title: "Tare",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M509.9 431.4l-68.43-267.7C436.2 142.7 417.9 128 397 128h-77.38c10.15-13.41 16.38-29.92 16.38-48c0-44.13-35.89-80-80.01-80S175.1 35.88 175.1 80c0 18.08 6.23 34.59 16.38 48H114.1C94.1 128 75.8 142.7 70.53 163.6l-68.45 267.8c-5.08 19.81-.75 41.13 11.6 57.03C25.29 503.4 42.53 512 60.95 512h390.1c18.42 0 35.66-8.594 47.27-23.59C510.7 472.5 514.1 451.2 509.9 431.4zM256 32c26.47 0 48.01 21.53 48.01 48S282.5 128 256 128S207.1 106.5 207.1 80S229.5 32 256 32zM473 468.8C467.4 476 459.6 480 451 480H60.95c-8.578 0-16.39-3.969-21.99-11.19c-6.33-8.156-8.518-19.16-5.877-29.47L101.6 171.5C103.3 164.7 108.8 160 114.1 160h282c6.205 0 11.74 4.719 13.46 11.56l68.45 267.8C481.6 449.6 479.4 460.7 473 468.8z"/></svg>',
                prefix: "Tare: ",
                suffix: " kg",
            },

            widthOfTheUnit: {
                title: "External width",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M507.3 267.3l-112 112C392.2 382.4 388.1 384 384 384s-8.188-1.562-11.31-4.688c-6.25-6.25-6.25-16.38 0-22.62L457.4 272H54.63l84.69 84.69c6.25 6.25 6.25 16.38 0 22.62C136.2 382.4 132.1 384 128 384s-8.188-1.562-11.31-4.688l-112-112c-6.25-6.25-6.25-16.38 0-22.62l112-112c6.25-6.25 16.38-6.25 22.62 0s6.25 16.38 0 22.62L54.63 240h402.8l-84.69-84.69c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0l112 112C513.6 250.9 513.6 261.1 507.3 267.3z"/></svg>',
                prefix: "External width: ",
                suffix: " mm ",
            },

            mainGarageDimensions: {
                title: "Main garage dimensions",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M507.3 267.3l-112 112C392.2 382.4 388.1 384 384 384s-8.188-1.562-11.31-4.688c-6.25-6.25-6.25-16.38 0-22.62L457.4 272H54.63l84.69 84.69c6.25 6.25 6.25 16.38 0 22.62C136.2 382.4 132.1 384 128 384s-8.188-1.562-11.31-4.688l-112-112c-6.25-6.25-6.25-16.38 0-22.62l112-112c6.25-6.25 16.38-6.25 22.62 0s6.25 16.38 0 22.62L54.63 240h402.8l-84.69-84.69c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0l112 112C513.6 250.9 513.6 261.1 507.3 267.3z"/></svg>',
                prefix: "Main garage dimensions: ",
                suffix: " mm ",
            },

            internalHeightOfTheUnit: {
                title: "Internal height",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="w-4" style="height:1.25rem"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M139.3 4.688l112 112C254.4 119.8 256 123.9 256 128s-1.562 8.188-4.688 11.31c-6.25 6.25-16.38 6.25-22.62 0L144 54.63v402.8l84.69-84.69c6.25-6.25 16.38-6.25 22.62 0C254.4 375.8 256 379.9 256 384s-1.562 8.188-4.688 11.31l-112 112c-6.25 6.25-16.38 6.25-22.62 0l-112-112c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0L112 457.4V54.63L27.31 139.3c-6.25 6.25-16.38 6.25-22.62 0s-6.25-16.38 0-22.62l112-112C122.9-1.562 133.1-1.562 139.3 4.688z"/></svg>',
                prefix: "Internal height: ",
                suffix: " mm ",
            },

            internalWidth: {
                title: "Internal width",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M507.3 267.3l-112 112C392.2 382.4 388.1 384 384 384s-8.188-1.562-11.31-4.688c-6.25-6.25-6.25-16.38 0-22.62L457.4 272H54.63l84.69 84.69c6.25 6.25 6.25 16.38 0 22.62C136.2 382.4 132.1 384 128 384s-8.188-1.562-11.31-4.688l-112-112c-6.25-6.25-6.25-16.38 0-22.62l112-112c6.25-6.25 16.38-6.25 22.62 0s6.25 16.38 0 22.62L54.63 240h402.8l-84.69-84.69c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0l112 112C513.6 250.9 513.6 261.1 507.3 267.3z"/></svg>',
                prefix: "Internal width: ",
                suffix: " mm ",
            },

            driversLicense: {
                title: "Driver's license",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M352 352h128c8.836 0 16-7.164 16-16S488.8 320 480 320h-128c-8.836 0-16 7.164-16 16S343.2 352 352 352zM512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM544 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128h512V416zM32 96c0-17.64 14.36-32 32-32h448c17.64 0 32 14.36 32 32H32zM352 224h128c8.836 0 16-7.164 16-16S488.8 192 480 192h-128c-8.836 0-16 7.164-16 16S343.2 224 352 224zM352 288h128c8.836 0 16-7.164 16-16S488.8 256 480 256h-128c-8.836 0-16 7.164-16 16S343.2 288 352 288zM192 288c35.35 0 64-28.65 64-64S227.3 160 192 160S128 188.7 128 224S156.7 288 192 288zM192 192c17.64 0 32 14.36 32 32S209.6 256 192 256S160 241.6 160 224S174.4 192 192 192zM96 416c8.836 0 16-7.164 16-16C112 373.5 133.5 352 160 352h64c26.51 0 48 21.49 48 48c0 8.836 7.164 16 16 16s16-7.164 16-16c0-44.18-35.82-80-80-80H160c-44.18 0-80 35.82-80 80C80 408.8 87.16 416 96 416z"/></svg>',
                prefix: "Driver's license: ",
                suffix: "",
            },

            ////
            ///
            entertainmentTv: {
                title: "Entertainment",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M448 96L299.2 96l79.17-67.86c6.719-5.75 7.5-15.84 1.75-22.55c-5.781-6.734-15.88-7.469-22.56-1.734L256 90.92L154.4 3.859c-6.656-5.734-16.75-5-22.56 1.734C126.1 12.3 126.9 22.39 133.6 28.14L212.8 96L64 96c-35.35 0-64 28.65-64 63.1v287.1C0 483.3 28.65 512 64 512h384c35.35 0 64-28.65 64-63.1V160C512 124.7 483.3 96 448 96zM480 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V160c0-17.64 14.36-32 32-32h384c17.64 0 32 14.36 32 32V448zM320.1 160L128.1 160c-35.35 0-64 28.65-64 64v160c0 35.35 28.65 64 64 64l191.1 .0002c35.35 0 64.01-28.65 64.01-64V224C384.1 188.7 355.4 160 320.1 160zM352 384c0 17.64-14.36 32-32 32H128c-17.64 0-32-14.36-32-32V224c0-17.64 14.36-32 32-32h192c17.64 0 32 14.36 32 32V384zM432 184c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C456 194.7 445.3 184 432 184zM432 248c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C456 258.7 445.3 248 432 248z"/></svg>',
                prefix: "",
                suffix: "",
            },

            oven: {
                title: "",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M352 0H96C42.98 0 0 42.98 0 96v352c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 42.98 405 0 352 0zM416 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V192h384V448zM416 160H32V96c0-35.29 28.71-64 64-64h256c35.29 0 64 28.71 64 64V160zM96 448h256c17.67 0 32-14.33 32-32V256c0-17.67-14.33-32-32-32H96C78.33 224 64 238.3 64 256v160C64 433.7 78.33 448 96 448zM96 256h256v160H96V256zM304 288h-160C135.2 288 128 295.2 128 304C128 312.8 135.2 320 144 320h160c8.836 0 16-7.164 16-16C320 295.2 312.8 288 304 288zM80 96C71.16 96 64 103.2 64 112C64 120.8 71.16 128 80 128S96 120.8 96 112C96 103.2 88.84 96 80 96zM176 96C167.2 96 160 103.2 160 112C160 120.8 167.2 128 176 128S192 120.8 192 112C192 103.2 184.8 96 176 96zM272 96C263.2 96 256 103.2 256 112C256 120.8 263.2 128 272 128S288 120.8 288 112C288 103.2 280.8 96 272 96zM368 96C359.2 96 352 103.2 352 112C352 120.8 359.2 128 368 128S384 120.8 384 112C384 103.2 376.8 96 368 96z"/></svg>',
                prefix: "",
                suffix: "",
            },

            fridge: {
                title: "",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M288 0H96C42.98 0 0 42.98 0 96v352c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V96C384 42.98 341 0 288 0zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V192h224v176c0 8.836 7.164 16 16 16s16-7.164 16-16V192h64V448zM352 160h-64V112C288 103.2 280.8 96 272 96S256 103.2 256 112V160H32V96c0-35.35 28.65-64 64-64h192c35.35 0 64 28.65 64 64V160z"/></svg>',
                prefix: "",
                suffix: "",
            },

            bedLayouts: {
                title: "Main bed configuration",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M528 128h-256C263.2 128 256 135.2 256 144V320H32V48C32 39.2 24.8 32 16 32S0 39.2 0 48v416C0 472.8 7.199 480 16 480S32 472.8 32 464V416h576v48c0 8.801 7.199 16 16 16s16-7.199 16-16v-224C640 178.1 589.9 128 528 128zM608 384H32v-32h576V384zM608 320H288V160h240C572.1 160 608 195.9 608 240V320zM144 288C188.1 288 224 252.1 224 208S188.1 128 144 128S64 163.9 64 208S99.88 288 144 288zM144 160C170.5 160 192 181.5 192 208S170.5 256 144 256S96 234.5 96 208S117.5 160 144 160z"/></svg>',
                prefix: "",
                suffix: "",
            },

            bedDescription: {
                title: "Secondary Bed Configuration",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M480 240.4V96c0-35.3-28.72-64-64-64H96C60.72 32 32 60.7 32 96v144.4C12.69 255 0 277.1 0 304v160C0 472.8 7.156 480 16 480S32 472.8 32 464V416h448v48c0 8.844 7.156 16 16 16s16-7.156 16-16v-160C512 277.1 499.3 255 480 240.4zM432 224h-160V192c0-17.64 14.34-32 32-32H416c17.66 0 32 14.36 32 32v33.62C442.8 224.6 437.5 224 432 224zM96 64h320c17.66 0 32 14.36 32 32v40.9C438.5 131.4 427.7 128 416 128h-112c-19.2 0-36.26 8.678-48 22.12C244.3 136.7 227.2 128 208 128H96C84.29 128 73.45 131.4 64 136.9V96C64 78.36 78.34 64 96 64zM64 192c0-17.64 14.34-32 32-32h112c17.66 0 32 14.36 32 32v32h-160C74.52 224 69.17 224.6 64 225.6V192zM480 384H32V304C32 277.5 53.53 256 80 256h352C458.5 256 480 277.5 480 304V384z"/></svg>',
                prefix: "",
                suffix: "",
            },

            garageStorage: {
                title: "Number of external lockers",
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="w-5"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="currenColor" d="M326.2 35.98C322.2 34.3 317.8 34.3 313.8 35.98L51.58 146.4C39.72 151.4 32 162.1 32 175.9V496C32 504.8 24.84 512 16 512C7.164 512 0 504.8 0 496V175.9C0 150.1 15.43 126.9 39.16 116.9L301.4 6.484C313.3 1.469 326.7 1.469 338.6 6.484L600.8 116.9C624.6 126.9 640 150.1 640 175.9V496C640 504.8 632.8 512 624 512C615.2 512 608 504.8 608 496V175.9C608 162.1 600.3 151.4 588.4 146.4L326.2 35.98zM96 224C96 206.3 110.3 192 128 192H512C529.7 192 544 206.3 544 224V496C544 504.8 536.8 512 528 512C519.2 512 512 504.8 512 496V224H128V496C128 504.8 120.8 512 112 512C103.2 512 96 504.8 96 496V224zM480 416V464C480 490.5 458.5 512 432 512H208C181.5 512 160 490.5 160 464V303.1C160 277.5 181.5 255.1 208 255.1H304C330.5 255.1 352 277.5 352 303.1V368H432C458.5 368 480 389.5 480 416zM352 400V480H432C440.8 480 448 472.8 448 464V416C448 407.2 440.8 400 432 400H352zM320 480V400H192V464C192 472.8 199.2 480 208 480H320zM304 287.1H208C199.2 287.1 192 295.2 192 303.1V368H320V303.1C320 295.2 312.8 287.1 304 287.1z"/></svg>',
                prefix: "",
                suffix: "",
            },
        }); // mini library for all the icons displayed on the comparison tables. includes their titles, suffix etc

        // API call to get the more detailed info from model1 and model2
        async function getModelsById() {
            models.value = await axios
                .post("/api/models", {
                    [window.csrfTokenName]: window.csrfTokenValue,
                    idArray: [model1.value?.id, model2.value?.id], // the API call will know which model thanks to their IDs
                    detailed: true,
                })
                .then(({ data }) => {
                    loading.value = false;
                    return data;
                })
                .catch((reason) => {
                    loading.value = false;
                    console.log(reason);
                    return [];
                });
        }

        onMounted(async () => {
            // get all the models via API and load them in the 'models' variable
            allModels.value = await axios
                .post("/api/all-models", {
                    [window.csrfTokenName]: window.csrfTokenValue,
                })
                .then(({ data }) => {
                    loading.value = false;
                    return data;
                })
                .catch((reason) => {
                    loading.value = false;
                    console.log(reason);
                    return [];
                });

            app.value = document.getElementById("app");
            header.value = document.getElementsByClassName("section-header")[0];

            // check if we have any models on our cookies and load them
            if (Cookies.get("model1")) {
                model1.value = allModels.value.find(
                    (curModel) => curModel.slug === Cookies.get("model1")
                );
            }
            if (Cookies.get("model2")) {
                model2.value = allModels.value.find(
                    (curModel) => curModel.slug === Cookies.get("model2")
                );
            }
        });

        function openModal(model = false) {
            if (model) {
                galleryModel.value = model;
            }

            displayGalleryModal.value = !displayGalleryModal.value;

            if (displayGalleryModal.value) {
                const scrollY =
                    document.documentElement.style.getPropertyValue(
                        "--scroll-y"
                    );
                app.value.style.position = "fixed";
                app.value.style.width = "100%";
                app.value.style.top = `-${scrollY}`;
                if (header.value) {
                    header.value.style.zIndex = "10";
                }
            } else {
                app.value.style.position = "";
                app.value.style.top = "";
                if (header.value) {
                    header.value.style.zIndex = "50";
                }
            }
        }

        // watch if the model1 and model2 have new values and then get their info, and load them in a cookie
        watch(
            () => [model1.value, model2.value],
            (first, second) => {
                if (
                    model2.value &&
                    model1.value &&
                    model1.value !== model2.value
                ) {
                    loading.value = true;
                    getModelsById();
                    Cookies.set("model1", model1.value?.slug); // set the model1 into a cookie
                    Cookies.set("model2", model2.value?.slug); // set the model2 into a cookie
                }
            }
        );

        return {
            models,
            allModels,
            loading,
            model1,
            model2,
            icons,
            modules: [Navigation, Pagination, A11y, Keyboard],
            header,
            galleryModel,
            displayGalleryModal,
            openModal,
            app,
        };
    },
};
</script>
